import Maple151 from "../Summarecon Bogor/Maple 15.webp"
import Maple152 from "../Summarecon Bogor/Maple 15.webp"

const Maple15images =[
    Maple151,Maple152
]

export default Maple15images;